import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const IsInModalContext = React.createContext({
    isInModal: false,
});
export const IsInModalContextProvider = (props) => {
    return (_jsx(IsInModalContext.Provider, { value: { isInModal: true }, children: props.children }));
};
const useIsInModal = () => {
    return React.useContext(IsInModalContext).isInModal;
};
export default useIsInModal;
